// User contact info
export * from "./contactInfo.component";
export * from "./contactInfo.service";



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/contactInfo/index.ts